import { useLocation } from '@app/router';
import { useMemo } from 'react';

const NO_FOOTER_PAGES = [
  'forgotpassword',
  'resetpassword',
  'sell',
  'buy',
  'settings/payout',
  'settings/profile',
  'settings/buying',
  'settings/seller',
  'settings/shipping',
  'signup',
  'login',
  'selling',
  'social-confirm',
  'gdpr',
  'reset-password-confirmation',
  'shipments',
];

const useIsNonFooterPage = (): boolean => {
  const { pathname, search } = useLocation();

  return useMemo(() => {
    if (search.includes('source=mobile')) {
      return true;
    }

    return NO_FOOTER_PAGES.some((path) => pathname.includes(path));
  }, [pathname, search]);
};

export default useIsNonFooterPage;
